import { render, staticRenderFns } from "./representivesTable.vue?vue&type=template&id=09bf5c98&"
import script from "./representivesTable.vue?vue&type=script&lang=js&"
export * from "./representivesTable.vue?vue&type=script&lang=js&"
import style0 from "./representivesTable.vue?vue&type=style&index=0&id=09bf5c98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports